import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, CheckCircle2 } from 'lucide-react';
export function ProductReveal() {
  return <section className="w-full max-w-3xl mx-auto px-6 py-16" data-id="element-167">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="space-y-12" data-id="element-168">
        <div className="text-center space-y-4" data-id="element-169">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy" data-id="element-170">
            Presento: Planeación 10X
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-171">
            Un sistema simple (pero serio) para construir clases sólidas en 15
            minutos, sin partir de cero.
          </p>
        </div>

        <div className="space-y-6" data-id="element-172">
          <h3 className="text-2xl font-serif font-bold text-navy border-b border-gray-200 pb-2" data-id="element-173">
            ¿Qué lo hace diferente?
          </h3>
          <p className="text-lg text-gray-700" data-id="element-174">
            No es “otro formato”. Es una línea de ensamblaje:
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2" data-id="element-175">
          <motion.div whileHover={{
          y: -5
        }} className="bg-navy text-white p-8 rounded-xl shadow-xl relative overflow-hidden" data-id="element-176">
            <div className="absolute top-0 right-0 w-24 h-24 bg-teal/10 rounded-full -mr-10 -mt-10" data-id="element-177"></div>
            <h4 className="text-2xl font-serif font-bold text-teal mb-4" data-id="element-178">
              1) Mapa 3C
            </h4>
            <ul className="space-y-3 text-gray-300" data-id="element-179">
              <li className="flex gap-2" data-id="element-180">
                <span className="font-bold text-white" data-id="element-181">Competencia:</span> qué
                habilidad observable practican
              </li>
              <li className="flex gap-2" data-id="element-182">
                <span className="font-bold text-white" data-id="element-183">Contenido:</span> con qué
                tema se practica
              </li>
              <li className="flex gap-2" data-id="element-184">
                <span className="font-bold text-white" data-id="element-185">Criterio:</span> cómo se
                ve “bien hecho”
              </li>
            </ul>
            <p className="mt-6 text-sm text-teal italic border-t border-white/10 pt-4" data-id="element-186">
              Evita la planeación por “tema” que termina en explicación.
            </p>
          </motion.div>

          <motion.div whileHover={{
          y: -5
        }} className="bg-white border-2 border-navy text-navy p-8 rounded-xl shadow-xl" data-id="element-187">
            <h4 className="text-2xl font-serif font-bold text-navy mb-4" data-id="element-188">
              2) Bloque 7
            </h4>
            <div className="space-y-3 text-sm font-medium" data-id="element-189">
              <div className="flex items-center gap-2" data-id="element-190">
                <span className="w-6 h-6 rounded-full bg-amber text-navy flex items-center justify-center text-xs font-bold" data-id="element-191">
                  1
                </span>
                Inicio
              </div>
              <div className="flex items-center gap-2 pl-4 border-l-2 border-gray-100" data-id="element-192">
                <ArrowDown className="w-4 h-4 text-gray-400" data-id="element-193" />
                Gancho
              </div>
              <div className="flex items-center gap-2 pl-4 border-l-2 border-gray-100" data-id="element-194">
                <ArrowDown className="w-4 h-4 text-gray-400" data-id="element-195" />
                Modelo
              </div>
              <div className="flex items-center gap-2 pl-4 border-l-2 border-gray-100" data-id="element-196">
                <ArrowDown className="w-4 h-4 text-gray-400" data-id="element-197" />
                Práctica guiada
              </div>
              <div className="flex items-center gap-2 pl-4 border-l-2 border-gray-100" data-id="element-198">
                <ArrowDown className="w-4 h-4 text-gray-400" data-id="element-199" />
                Práctica independiente
              </div>
              <div className="flex items-center gap-2 pl-4 border-l-2 border-gray-100" data-id="element-200">
                <ArrowDown className="w-4 h-4 text-gray-400" data-id="element-201" />
                <span className="font-bold text-teal-600" data-id="element-202">Evidencia</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-203">
                <span className="w-6 h-6 rounded-full bg-navy text-white flex items-center justify-center text-xs font-bold" data-id="element-204">
                  7
                </span>
                Cierre
              </div>
            </div>
          </motion.div>
        </div>

        <div className="bg-cream border border-teal/30 p-8 rounded-lg text-center relative mt-12" data-id="element-205">
          <p className="text-2xl md:text-3xl font-serif font-bold text-navy leading-tight" data-id="element-206">
            “Si no hay evidencia, no hubo clase{' '}
            <span className="text-teal" data-id="element-207">(hubo plática)</span>.”
          </p>
          <p className="mt-4 text-gray-600" data-id="element-208">
            La evidencia no es burocracia. Es tu ancla: te ayuda a enseñar,
            evaluar y cerrar sin improvisar.
          </p>
        </div>
      </motion.div>
    </section>;
}